import { Component, OnInit, OnDestroy }   from '@angular/core';
import { ActivatedRoute }                 from '@angular/router';
import { UserService }                  from '../../_services/user.service'; 
import { Router }                         from '@angular/router';
import { AuthService }                    from '../../auth/ind/auth.service';
import { Credentials, Scope, Ops, User }  from '../../_models/index';
import { EqualValidator }               from '../../_directives/index';
//import { IMG_ANI_REFRESH}               from '../../_models/constants';
 //import { NgFlashService } from 'ng-flash';
 import { catchError, first } from 'rxjs/operators';
 import { Subscription, throwError } from 'rxjs';
@Component({
  selector: 'ind-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit, OnDestroy {

  parm: any;
  model: any;  
  credentials: Credentials;
  link: string;
  id_token: string;
  private sub: any;
  loading:boolean = false;
  success:boolean = false;
  user: User;
  subscription: Subscription | null = null;

  constructor(private route: ActivatedRoute,
          private userService: UserService,
          private router: Router, 
          private auth: AuthService)
           //private _ngFlashService: NgFlashService 
           { }

  ngOnInit() {
    //this.IMG_ANI_REFRESH = IMG_ANI_REFRESH;
    this.loading = false;
    this.success = false;
    this.sub = this.route.params.subscribe(params => {
      //alert('Param s:'+params['s']) ;
      this.parm = params['s'];
    });
    var urlqry = decodeURIComponent(this.parm);
    var result = {};
    urlqry.split("&").forEach(function(part) {
      var item = part.split("=");
      result[item[0]] = decodeURIComponent(item[1]);
    });
    var tmpObj = {"firstname":"", "lastname":"", "email":""};
    tmpObj.firstname = result['f'];
    tmpObj.lastname = result['l'];
    tmpObj.email = result['e']?.toLowerCase().trim();    
    this.model = tmpObj;  
    this.credentials = { email: result['e']?.toLowerCase().trim(), scope: Scope.BF_ENT, password: ""};    
    this.id_token = result['token'];

  }

  ngOnDestroy() {
    try{
      this.sub.unsubscribe();
      this.subscription?.unsubscribe();  
    }catch(e){

    }
  }

  resetPassword(){
    this.loading = true;    //alert('Credentials: '+JSON.stringify(this.credentials));
    this.userService.resetyourpassword(this.credentials, this.id_token)
      .pipe(
        first(),
        catchError(err => {
          console.log('Handling error and rethrowing: '+JSON.stringify(err));
          return throwError(err);
        }
        )
      )
      .subscribe(
      data => {//alert('Start Process done. Calling auth.login with: '+JSON.stringify(this.credentials));
        this.success = true;        
        this.subscription=this.auth.login(this.credentials)
          .pipe(first())
          .subscribe(
          (result:any) => {
              if (result.success){
                  /*var user = this.auth.loggedIn();
                  if (user){
                    this.user = user;
                  }else{
                    this.user = { id: '', email:'',  firstname: '', prefix: '', lastname: '' };
                  }*/
                  //this.auth.user = this.user;
                  this.user = this.auth.currentUserValue;    
                  this.router.navigate(["/ind/ind-home"]);
              }else{
                //this._flashMessagesService.show('Login failed', { cssClass: 'alert-success', timeout: 10000 });//alert('Login failed');
                console.log('Reset fail:'+result.message);
                //this._ngFlashService.danger('Login failed.');
                this.loading = false;    
                this.router.navigate(["/ind-login"]);         
              }
          },
          err => {
                /*switch (err.statusCode){
                  case 412:
                  //alert('User is not activated. Please check your email for activation email or click on Reset Your Password');
                  //this._flashMessagesService.show('User is not activated. Please check your email for activation email or click on Reset Your Password.', { cssClass: 'alert-success', timeout: 10000 });
                  this._ngFlashService.success('User is not activated. Please check your email for activation email or click on Reset Your Password.');
                  break;
                default:
                  //this._flashMessagesService.show('Invalid login. Please check the entered Email, Password and Sign In Type.', { cssClass: 'alert-success', timeout: 10000 });            
                  this._ngFlashService.success('Invalid login. Please check the entered Email, Password and Sign In Type.');
                  //alert('Invalid login. Please check the entered Email, Password and Sign In Type. ');
                }*/
                console.log("Reset pwd error:"+JSON.stringify(err));
                //this._ngFlashService.danger('Invalid login. Please check the entered Email, Password and Sign In Type.');
                this.loading = false;    
                this.router.navigate(["/ind-login"]);
              }
        );
      },
      error => {
        //alert('Starting Referral Process failed.'+JSON.stringify(error));
        //this._flashMessagesService.show('Starting Referral Process failed.'+JSON.stringify(error), { cssClass: 'alert-success', timeout: 10000 });        
        console.log('Reset pwd Process failed.'+JSON.stringify(error));
        //this._ngFlashService.danger('Reset pwd Process failed.');
        this.loading = false;    
        this.router.navigate(["/ind-login"]);
      }
    );
    
  }
}
